<script lang="ts">
	import { onMount } from 'svelte';
	import { Spinner, Button } from 'flowbite-svelte';
	import { push } from '../../svelte-spa-router';
	import { getStatusIncidents } from '../../AppNetwork';
	import type { PublicIncident } from '../../AppTypes';
	import IncidentCard from '../../components/public/IncidentCard.svelte';

	let incidents: PublicIncident[] = [];
	let total = 0;
	let page = 0;
	const limit = 20;
	let loading = true;
	let error = '';

	async function load() {
		loading = true;
		error = '';
		try {
			const result = await getStatusIncidents({ limit, offset: page * limit });
			incidents = result.items;
			total = result.total;
		} catch (e) {
			error = e instanceof Error ? e.message : 'Failed to load incidents';
		} finally {
			loading = false;
		}
	}

	onMount(load);
</script>

<button class="text-sm text-gray-500 hover:underline mb-4" on:click={() => push('/')}>← Back to status</button>
<h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-6">Incident History</h1>

{#if loading}
	<div class="flex justify-center py-20"><Spinner size="8" /></div>
{:else if error}
	<div class="text-center py-20 text-gray-500">{error}</div>
{:else if incidents.length === 0}
	<p class="text-center text-gray-400 py-10">No incidents reported.</p>
{:else}
	<div class="space-y-3">
		{#each incidents as incident}
			<IncidentCard {incident} />
		{/each}
	</div>
	{#if total > limit}
		<div class="flex justify-between items-center mt-6">
			<Button size="sm" color="alternative" disabled={page === 0} on:click={() => { page--; load(); }}>Previous</Button>
			<span class="text-sm text-gray-500">Page {page + 1} of {Math.ceil(total / limit)}</span>
			<Button size="sm" color="alternative" disabled={(page + 1) * limit >= total} on:click={() => { page++; load(); }}>Next</Button>
		</div>
	{/if}
{/if}
